import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, ShieldCheck, MapPin, Building2, Clock } from 'lucide-react';
import { BRAND } from '../lib/brand';
import { openWhatsApp, buildWhatsAppUrl } from '../lib/whatsapp';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-gradient-to-b from-[hsl(var(--background))] to-[#D4E3F4]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-8 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/brand/logo-light.png" alt="UnfallHeld" className="h-9 w-9 object-contain" />
            <div className="font-heading font-semibold text-[hsl(var(--primary))]">{BRAND.name}</div>
          </div>
          <p className="text-sm text-slate-600">{BRAND.tagline}</p>
          <p className="text-xs text-slate-500 mt-3">Ihr digitaler Unfall-Concierge in Österreich.</p>
        </div>

        <div>
          <div className="font-heading font-semibold mb-3 text-slate-900">Schnellkontakt</div>
          <ul className="space-y-2 text-sm">
            <li><a href={`tel:${BRAND.phone}`} className="inline-flex items-center gap-2 text-slate-700 hover:text-[hsl(var(--primary))]" data-testid="footer-phone-link"><Phone className="h-4 w-4" /> {BRAND.phoneDisplay}</a></li>
            <li>
              <a
                href={buildWhatsAppUrl('Hallo UnfallHeld, ich brauche Unterstützung.')}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => { e.preventDefault(); openWhatsApp('Hallo UnfallHeld, ich brauche Unterstützung.'); }}
                className="inline-flex items-center gap-2 text-slate-700 hover:text-[hsl(var(--primary))]"
                data-testid="footer-whatsapp-link"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp Kontakt
              </a>
            </li>
            <li><Link to="/notfall" className="inline-flex items-center gap-2 text-red-700 hover:text-red-800 font-medium" data-testid="footer-emergency-link"><ShieldCheck className="h-4 w-4" /> Notfallmodus</Link></li>
          </ul>
          <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
            <div className="flex items-center gap-1.5 font-medium text-slate-900">
              <Clock className="h-3.5 w-3.5 text-[hsl(var(--primary))]" /> {BRAND.hours.short}
            </div>
            <p className="mt-1 text-slate-600 leading-relaxed">
              {BRAND.hours.long}
            </p>
          </div>
        </div>

        <div>
          <div className="font-heading font-semibold mb-3 text-slate-900">Service</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li>Digitale Schadenmeldung</li>
            <li>KI-Schadensanalyse</li>
            <li>Zulassungsschein-OCR</li>
            <li>Sprach-Erfassung</li>
            <li>PDF-Schadenakte</li>
            <li>Versicherungs-Vorbereitung</li>
          </ul>
        </div>

        <div>
          <div className="font-heading font-semibold mb-3 text-slate-900">Unternehmen</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li className="flex items-start gap-2"><Building2 className="h-4 w-4 mt-0.5 text-[hsl(var(--primary))]" /><span>Rezart Gashi<br /><span className="text-xs text-slate-500">Einzelunternehmer</span></span></li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[hsl(var(--primary))]" /><span>Draschestraße 75<br />1230 Wien, Österreich</span></li>
            <li className="text-xs text-slate-500">UID: ATU76441646</li>
          </ul>
          <ul className="mt-3 space-y-1 text-sm">
            <li><Link to="/impressum" className="text-slate-700 hover:text-[hsl(var(--primary))] underline-offset-2 hover:underline" data-testid="footer-impressum-link">Impressum</Link></li>
            <li><Link to="/datenschutz" className="text-slate-700 hover:text-[hsl(var(--primary))] underline-offset-2 hover:underline" data-testid="footer-datenschutz-link">Datenschutzerklärung</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} {BRAND.name} · Rezart Gashi · Draschestraße 75, 1230 Wien · UID ATU76441646</p>
          <p className="text-xs text-slate-500">Im Notfall: 112 / 144 (Rettung) / 133 (Polizei)</p>
        </div>
      </div>
    </footer>
  );
}
